import Axios from 'axios'
import type {verificationType} from './CustomerVerificationType'

export const verifyOrder = (data:verificationType) => {

  return Axios.post(`${process.env.REACT_APP_API}/order/verify`, data);

}